import type { CoverBackground } from 'fym-shared/src/music24/coverDoc';
import { coverCropRect, gradientLine } from './coverGeometry';

type Ctx = CanvasRenderingContext2D;

/** A loaded picture and its pixel size. */
export interface CoverPicture {
  source: CanvasImageSource;
  width: number;
  height: number;
}

/** The colour under a picture that did not load yet. */
const EMPTY_GROUND = '#0d0c14';

/**
 * Draws the background of the cover on a square of `side` pixels: the picture (it covers the
 * square about its focus point, times its zoom), a colour or a gradient. A picture that is not
 * loaded yet leaves the dark ground.
 */
export function drawCoverBackground(
  ctx: Ctx,
  background: CoverBackground,
  side: number,
  picture: CoverPicture | null
): void {
  ctx.save();
  ctx.fillStyle = EMPTY_GROUND;
  ctx.fillRect(0, 0, side, side);
  if (background.kind === 'colour') {
    ctx.fillStyle = background.colour;
    ctx.fillRect(0, 0, side, side);
  } else if (background.kind === 'gradient') {
    const line = gradientLine(background.angleDeg, side);
    const gradient = ctx.createLinearGradient(line.x0, line.y0, line.x1, line.y1);
    gradient.addColorStop(0, background.from);
    gradient.addColorStop(1, background.to);
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, side, side);
  } else if (picture !== null) {
    const rect = coverCropRect(
      picture.width,
      picture.height,
      side,
      background.focusX,
      background.focusY,
      background.zoom
    );
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(picture.source, rect.dx, rect.dy, rect.dw, rect.dh);
  }
  ctx.restore();
}
